<template>
  <svg
    :class="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9212_68132)">
      <path
        d="M0 12.0003C0 13.4682 0.264047 14.8742 0.746391 16.1742L12 16.696L23.2536 16.1743C23.736 14.8742 24 13.4682 24 12.0003C24 10.5325 23.736 9.12644 23.2536 7.82645L12 7.30469L0.746391 7.82641C0.264047 9.12644 0 10.5325 0 12.0003H0Z"
        fill="#FFDA44"
      />
      <path
        d="M12.0002 0C6.84061 0 2.4421 3.2565 0.746582 7.82611H23.2538C21.5583 3.2565 17.1598 0 12.0002 0Z"
        fill="#D80027"
      />
      <path
        d="M23.2538 16.1738H0.746582C2.4421 20.7434 6.84061 23.9999 12.0002 23.9999C17.1598 23.9999 21.5583 20.7434 23.2538 16.1738Z"
        fill="#496E2D"
      />
      <path
        d="M12 7.82617L13.0359 11.0146H16.3888L13.6764 12.9854L14.7124 16.174L12 14.2033L9.28753 16.174L10.3237 12.9854L7.61133 11.0146H10.964L12 7.82617Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_9212_68132">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
